<template>
  <div class="bespread-wrap module-layer1">
    <div class="screen-container">
      <div class="kv-content">
        <img src="../../assets/img/layer1/bi.png" alt="" srcset="" class="bi" />
        <div class="kv-btn cursor"  @click="goReg()">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      // arrowFlag: true,
      // buiFlag: true
    };
  },
  watch: {},
  created() {},
  methods: {
    goReg() {
        gtag("event", "reg_page");
      this.$emit('handleReg')
    },
  }
};
</script>
<style lang="scss" scoped>
.module-layer1 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer1/bg.png ");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: 100%;
    .kv-content {
      position: absolute;
      bottom:12vw;
      left: 50%;
     
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      z-index: 1;
      gap: 2.5vw;
      .bi {
        width: auto;
        height: 459px;
      }

      .kv-btn {
        width: 363px;
        height: 120px;
        background-image: url("../../assets/img/layer1/reg-btn.png ");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
          &:hover {
        background-image: url("../../assets/img/layer1/reg-btn-hover.png ");
      }
      }
    
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer1 {
    .kv-content {
      bottom: 12vw !important;
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer1 {
    .kv-content {
      // bottom: 3vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue